export default "__VITE_ASSET__DiJsEawz__"